"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotificationPreferences;
var _react = _interopRequireWildcard(require("react"));
var _awsAmplify = require("aws-amplify");
var _NotificationPreferencesComponent = _interopRequireDefault(require("../components/NotificationPreferencesComponent"));
var _Services = require("../common_features/utility/Services");
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _userDetailsReducer = require("../common_features/redux/reducers/userDetailsReducer");
var _helper = require("../common_features/utility/helper");
var _loginReducer = require("../common_features/redux/reducers/loginReducer");
var _strings = require("../common_features/utility/strings");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function NotificationPreferences(props) {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [phoneNumber, setPhoneNumber] = (0, _react.useState)("");
  const [smsChecked, setSmsChecked] = (0, _react.useState)(false);
  const [checkboxChecked, setCheckboxChecked] = (0, _react.useState)(false);
  const [smsInviteModal, setSmsInviteModal] = (0, _react.useState)(false);
  const [smsPending, setSmsPending] = (0, _react.useState)(false);
  const [isNumberVerified, setIsNumberVerified] = (0, _react.useState)(false);
  const dispatch = (0, _reactRedux.useDispatch)();
  const [emailChange, setEmailChange] = (0, _react.useState)(false);
  let userNumber = (0, _reactRedux.useSelector)(state => {
    var _state$userDetails, _state$userDetails$da;
    return state === null || state === void 0 ? void 0 : (_state$userDetails = state.userDetails) === null || _state$userDetails === void 0 ? void 0 : (_state$userDetails$da = _state$userDetails.data) === null || _state$userDetails$da === void 0 ? void 0 : _state$userDetails$da.phoneNumber;
  });
  const navigate = (0, _reactRouterDom.useNavigate)();
  const location = (0, _reactRouterDom.useLocation)();
  function checkDisabled() {
    if (smsChecked) {
      return phoneNumber === null || (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) < 11 || false;
    } else {
      return false;
    }
  }
  const getRoleData = async () => {
    var _role$data;
    const role = await (0, _Services.getRoles)();
    let getRoleId = role === null || role === void 0 ? void 0 : (_role$data = role.data) === null || _role$data === void 0 ? void 0 : _role$data[0].roleId;
    return getRoleId;
  };
  const getUserData = async () => {
    setIsLoading(true);
    try {
      var _userDetailsData$data, _userDetailsData$data2, _userDetailsData$data3, _userDetailsData$data4, _userDetailsData$data5, _userDetailsData$data6, _userDetailsData$data7, _userDetailsData$data8, _userDetailsData$data9, _userDetailsData$data10, _userDetailsData$data11, _userDetailsData$data12, _userDetailsData$data13, _userDetailsData$data14, _userDetailsData$data15, _userDetailsData$data16, _userDetailsData$data17;
      let rolesID = await getRoleData();
      let getUser = await _awsAmplify.Auth.currentAuthenticatedUser();
      let userPoolId = getUser.pool.userPoolId;
      let authUsername = getUser.username;
      let userID = "".concat(userPoolId, "#").concat(authUsername);
      let updatedUserId = userID;
      const userDetailsData = await (0, _Services.getUsers)(rolesID, updatedUserId);
      let phnNumber = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data = userDetailsData.data) === null || _userDetailsData$data === void 0 ? void 0 : _userDetailsData$data.phoneNumber;
      setPhoneNumber(phnNumber);
      let checkEmail = (_userDetailsData$data2 = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data3 = userDetailsData.data) === null || _userDetailsData$data3 === void 0 ? void 0 : (_userDetailsData$data4 = _userDetailsData$data3.UserNotifyPref) === null || _userDetailsData$data4 === void 0 ? void 0 : (_userDetailsData$data5 = _userDetailsData$data4.pref) === null || _userDetailsData$data5 === void 0 ? void 0 : _userDetailsData$data5.email) !== null && _userDetailsData$data2 !== void 0 ? _userDetailsData$data2 : false;
      setEmailChange(checkEmail);
      let smsCheck = (_userDetailsData$data6 = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data7 = userDetailsData.data) === null || _userDetailsData$data7 === void 0 ? void 0 : (_userDetailsData$data8 = _userDetailsData$data7.UserNotifyPref) === null || _userDetailsData$data8 === void 0 ? void 0 : (_userDetailsData$data9 = _userDetailsData$data8.pref) === null || _userDetailsData$data9 === void 0 ? void 0 : _userDetailsData$data9.sms) !== null && _userDetailsData$data6 !== void 0 ? _userDetailsData$data6 : false;
      setSmsChecked(smsCheck);
      let HelpFulCheck = (_userDetailsData$data10 = userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data11 = userDetailsData.data) === null || _userDetailsData$data11 === void 0 ? void 0 : (_userDetailsData$data12 = _userDetailsData$data11.UserNotifyPref) === null || _userDetailsData$data12 === void 0 ? void 0 : (_userDetailsData$data13 = _userDetailsData$data12.pref) === null || _userDetailsData$data13 === void 0 ? void 0 : _userDetailsData$data13.helpfulTips) !== null && _userDetailsData$data10 !== void 0 ? _userDetailsData$data10 : false;
      setCheckboxChecked(HelpFulCheck);
      let smsPendingState = (userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data14 = userDetailsData.data) === null || _userDetailsData$data14 === void 0 ? void 0 : (_userDetailsData$data15 = _userDetailsData$data14.UserNotifyPref) === null || _userDetailsData$data15 === void 0 ? void 0 : _userDetailsData$data15.smsVerificationStatus) === 2 ? true : false;
      setSmsPending(smsPendingState);
      let numVerified = (userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$data16 = userDetailsData.data) === null || _userDetailsData$data16 === void 0 ? void 0 : (_userDetailsData$data17 = _userDetailsData$data16.UserNotifyPref) === null || _userDetailsData$data17 === void 0 ? void 0 : _userDetailsData$data17.smsVerificationStatus) === 1 ? true : false;
      setIsNumberVerified(numVerified);
      setIsLoading(false);
      dispatch((0, _userDetailsReducer.userDetailsInfo)(userDetailsData.data));
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };
  (0, _react.useEffect)(() => {
    getUserData();
  }, []);
  const userInfo = () => {
    _awsAmplify.Auth.currentAuthenticatedUser().then(user => {
      let userType = user.signInUserSession.accessToken.payload["cognito:groups"][0];
      let roleId = (0, _helper.getUserTypeFromGroup)(userType);
      (0, _helper.setUserDetails)(_loginReducer.loginUserInfo, dispatch, roleId, user);
    });
  };
  const handleSubmitNotificationPref = async () => {
    setSmsInviteModal(false);
    setIsLoading(true);
    await (0, _Services.GetNotification)(emailChange, smsChecked, checkboxChecked, phoneNumber).then(apiResp => {
      if (apiResp && apiResp.response.success) {
        userInfo();
        setIsLoading(false);
        navigate(_RoutePath.default.admin.path);
      } else {
        alert("Something went wrong, please try again.");
      }
      setIsLoading(false);
    }).catch(error => {
      console.log(error);
      alert(error);
      setIsLoading(false);
    });
  };
  const saveNotificationPref = e => {
    setSmsInviteModal(true);
    setIsLoading(false);
  };
  const handleCancelModal = () => {
    setSmsInviteModal(false);
  };
  const handleEmailChange = e => {
    setEmailChange(e);
  };
  const onClickSave = () => {
    if (smsChecked && isNumberVerified) {
      handleSubmitNotificationPref();
    } else if (smsChecked) {
      saveNotificationPref();
    } else {
      handleSubmitNotificationPref();
    }
  };
  const handleBackToEditProfile = () => {
    navigate(-1);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_NotificationPreferencesComponent.default, {
    leftArrow: _images.default.leftArrow.default,
    backNavigationScreen: "Edit Profile",
    handleBack: handleBackToEditProfile,
    fromEditProfile: location.pathname === "/Admin/NotificationPreferences" ? true : false,
    isLoading: isLoading,
    headerImage: _images.default.pentairLogo.default,
    modalHeaderTextNotifyPref: "Text Message Opt-In Confirmation",
    modalDetailTextNotifyPref: _strings.termsString.MAIN_CONTENT,
    reInviteModalNotifyPref: smsInviteModal,
    positiveActionButtonTitleNotifyPref: "I Confirm",
    negativeButtonActionTitleNotifyPref: "Cancel",
    handleResendInviteModalNP: handleSubmitNotificationPref,
    onClickSave: onClickSave,
    handleSetReInviteCancelModalNP: handleCancelModal,
    NotificationImage: _images.default.notification.default,
    headerText: "Notification Preferences",
    headerSubText: "Non-critical alerts will only be sent between 9am to 8pm based on store location. Critical alerts will be sent immediately.",
    emailNotificationsText: "Email Notifications",
    smsNotificationsText: "SMS Notifications",
    pendingText: "Pending",
    phoneNumberText: "Mobile Phone Number",
    notificationSubText: "This will be used for SMS notifications",
    numberInvalidText: "Please enter a valid phone number",
    checkboxContentText: "Receive helpful tips and tricks, product updates, surveys and special offers.",
    saveButtonText: "Save",
    phoneNumber: phoneNumber,
    numberDisabled: userNumber ? true : false,
    isValidPhoneNumber: (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) > 10 ? true : false,
    isPending: smsPending,
    onChangePhoneNumber: e => {
      setPhoneNumber(e);
    },
    emailChecked: emailChange,
    changeEmailChecked: e => {
      handleEmailChange(e);
    },
    smsChecked: smsChecked,
    changeSmsChecked: e => {
      setSmsChecked(e);
    },
    isSmsSelected: smsChecked ? true : false,
    checkboxChecked: checkboxChecked,
    changeCheckBox: () => {
      setCheckboxChecked(!checkboxChecked);
    },
    onClickSaveDisabled: checkDisabled()
  }));
}